// Display names for parties whose official Knesset faction name is too long
// to show in the UI. Keyed by the full (trimmed) official name.
const SHORT_NAME_OVERRIDES: Record<string, string> = {
  'התאחדות הספרדים שומרי תורה תנועתו של מרן הרב עובדיה יוסף זצ"ל': 'ש"ס',
};

// Short display name for a party: explicit overrides first, otherwise drop a
// trailing "בראשות ..." leader suffix (e.g. 'נעם - בראשות אבי מעוז' → 'נעם').
export function shortPartyName(name: string): string {
  const trimmed = (name || '').trim();
  if (Object.prototype.hasOwnProperty.call(SHORT_NAME_OVERRIDES, trimmed)) return SHORT_NAME_OVERRIDES[trimmed];
  if (trimmed.indexOf('התאחדות הספרדים') === 0) return 'ש"ס';
  const stripped = trimmed.replace(/\s*-?\s*בראשות.*$/, '').trim();
  return stripped || trimmed;
}

// Whether a Knesset's factions have a coalition: one of them is marked isCoalition (set by
// hand once a government is sworn in). Before that nobody is in opposition either.
export function hasCoalition(parties: Array<{ isCoalition?: boolean }>): boolean {
  return parties.some(p => p.isCoalition === true);
}
